import styled from 'styled-components';
import { HeImgix } from '../../../../../../common/components/images/HeImgix';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';

interface Props {
  image: string;
}

export const Portrait = ({ image }: Props) => (
  <View>
    <HeImgix
      height={72}
      width={72}
      src={image}
      imgixParams={{
        fit: 'facearea',
        facepad: 1.5,
      }}
      htmlAttributes={{ alt: '', draggable: false }}
    />
  </View>
);

const View = styled.div`
  align-items: center;
  background-color: ${ThemeColours.mono200};
  border: solid 1px ${ThemeColours.mono200};
  border-radius: 100%;
  display: flex;
  flex-shrink: 0;
  height: 72px;
  justify-content: center;
  margin-inline-start: 8px;
  overflow: hidden;
  user-select: none;
  width: 72px;
`;
